import styles from "./HxfIonPopup.module.scss";
import {
    IonButton,
    IonModal,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonInput,
    IonIcon
  } from '@ionic/react';
import useHxfTranslation from "../../../../barrel/hooks/useHxfTranslation";
import { closeOutline } from "ionicons/icons";
import styled from "@emotion/styled";
import { CSSProperties } from "styled-components";
interface IModalSettings{
    mode?:null | "fullscreen";
    disableOverflowScroll?:boolean;
    contentHeightPct?:any;

    customPopupHeight?:any;
    customPopupMaxHeight?:any;
    customPopupMinHeight?:any;

    customPopupMaxWidth?:any;
    isFullWidth?:boolean;
    
    

}
interface IProps{
    onDismiss?:any;
    style?:any;
    dataPopupContainerValue?:any;
    className?:any;
    content?:any;
    onClose?:any;
    bottomConfirmationContainer?:any;
    modelSettings?:IModalSettings;
    title?:any;
    customModalStyle?:any;
    refContentContainer?:any;
    modeIonPageContainer?:boolean;
}
const noFullscreen = `
.hxf-modal{
--max-width:90%;
--max-height:90%;
--backdrop-opacity: 0.53;
}

`;


function HxfIonPopup(props: IProps) {

  const getCustomHeightStyle = () => {
    let strStyle = "";
    if(props?.modelSettings?.customPopupHeight){
      strStyle += "--height:" + props?.modelSettings?.customPopupHeight + ";";
    }

      if(props?.modelSettings?.customPopupMaxHeight){
      strStyle += "--max-height:" + props?.modelSettings?.customPopupMaxHeight + ";";
    }
    if(props?.modelSettings?.customPopupMinHeight){
      
      strStyle += "--min-height:" + props?.modelSettings?.customPopupMinHeight + ";";
    }
    return strStyle;
  }

  const getCustomWidthStyle = () => {
    let strStyle = "";
    if(props?.modelSettings?.customPopupMaxWidth){
      strStyle += "--max-width:" + props?.modelSettings?.customPopupMaxWidth + ";";
    }
   
    return strStyle;
  }
  const customModalHeight = `.hxf-custom-modal{
    `
    + getCustomHeightStyle() +
    `

    ` 
    + getCustomWidthStyle() +
    `
  }`;


  const customModalFullWidth = `.hxf-full-width{
    --width: 100%;
   
}`;
  const {t} = useHxfTranslation();
  const getCustomStyle = () =>{
    
    if(!props?.style){
      return {};
    }
    return {...props.style};
  }

  const getContentHeight = () => {
    if(props?.modelSettings?.contentHeightPct){
      return props.modelSettings.contentHeightPct;
    }
    if(!props.bottomConfirmationContainer){
        return 100;
    }

    return 75;
  }


  const getBottomContainerStyles = ():CSSProperties => {
    let calculateBOTTOMPCT = false;

    if(!calculateBOTTOMPCT){
      return {};
    }
    return {height:getBottomHeight() + "%"}; //deprecated ( ?) it was messing up the height auto scaling for the bottom.
  }
  const getBottomHeight = () => {
    let remaining = 100 - getContentHeight();
    return remaining;
  }

  return (
    <div className={"noFullScreenIonModal"}>
     <style>{noFullscreen}</style>
     <style>{customModalHeight}</style>
     {props?.modelSettings?.isFullWidth && (
      <style>{customModalFullWidth}</style>
     )}
     <IonModal class={`hxf-custom-modal hxf-modal ${props?.modelSettings?.isFullWidth ? "hxf-full-width" : ""} ${props.modelSettings?.mode === "fullscreen" ? "modal-fullscreen" : ""}` } trigger="open-modal" isOpen={true} backdropDismiss={false} onDidDismiss={() => {
        if(props?.onDismiss){
            props.onDismiss();
        }
     }} style={props?.customModalStyle}>
        <div className={`${styles.barContainer}`}>
            <div></div>

            <div className={styles.title}>{props?.title}</div>

            <IonButton
                color="danger"
                className={styles.closeWindowButton}
                onClick={() => {
                if (props?.onClose) {
                    props.onClose();
                }
                }}
            >
                <IonIcon slot="icon-only" size="large" icon={closeOutline} />
            </IonButton>
        </div>
        <div
            ref={props?.refContentContainer}
            data-popup-container={props?.dataPopupContainerValue ? props.dataPopupContainerValue : null}
            style={{height:getContentHeight() + "%"}}
            className={` ${styles.contentContainer} ${props.modelSettings?.disableOverflowScroll ? "": styles.overflowScroll} `}
        >
          {props?.modeIonPageContainer ? (
            <div style={{position:'absolute',top:44,width:'100%',height:'100%'}}>
                {props.content}
              </div>
          ): (
            <>{props.content}</>
          )}
           
        </div>
        {props.bottomConfirmationContainer && (
            <>
                <div className={styles.dividerContainer}>
                    <div className={styles.divider}></div>
                </div>
            
                <div className={styles.bottomContainer} style={getBottomContainerStyles()} >
                    {props.bottomConfirmationContainer}
                </div>
            </>

        )}
      </IonModal>
    </div>
  );
}

export default HxfIonPopup;
